import { useState } from "react";
import { Check, Facebook, Link2, Share2 } from "lucide-react";

type Props = { title: string; path: string };

export function ShareButtons({ title, path }: Props) {
  const [copied, setCopied] = useState(false);
  const url = `https://www.akhusbilfritid.se${path}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      /* noop */
    }
  };

  const native = async () => {
    if (typeof navigator !== "undefined" && "share" in navigator) {
      try {
        await (navigator as Navigator & { share: (d: ShareData) => Promise<void> }).share({
          title,
          url,
        });
        return;
      } catch {
        /* fall through to copy */
      }
    }
    void copy();
  };

  const btn =
    "inline-flex items-center gap-2 rounded-full border border-border bg-card px-4 py-2 text-xs font-medium text-foreground/80 transition hover:border-accent hover:text-accent";

  return (
    <div className="mt-8 flex flex-wrap items-center gap-2">
      <span className="text-xs uppercase tracking-wider text-muted-foreground">Dela</span>
      <button type="button" onClick={native} className={btn} aria-label="Dela inlägget">
        <Share2 size={14} /> Dela
      </button>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        className={btn}
        aria-label="Dela på Facebook"
      >
        <Facebook size={14} /> Facebook
      </a>
      <button type="button" onClick={copy} className={btn} aria-label="Kopiera länk">
        {copied ? <Check size={14} /> : <Link2 size={14} />}
        {copied ? "Länk kopierad" : "Kopiera länk"}
      </button>
    </div>
  );
}
